import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=1bed7476&scoped=true&"
import script from "./BookingPage.vue?vue&type=script&lang=js&"
export * from "./BookingPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=1bed7476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed7476",
  null
  
)

export default component.exports